import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareCardLineCountMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  cardLineCount?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateShareCardLineCountMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardLineCount?: number | null } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardLineCount?: number | null } } | null } | null };


export const UpdateShareCardLineCount = /*#__PURE__*/ gql`
    mutation UpdateShareCardLineCount($shareId: ID!, $cardLineCount: Int) {
  updateShare(
    input: {shareId: $shareId, appearance: {cardLineCount: $cardLineCount}}
  ) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          cardLineCount
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareCardLineCountMutation, UpdateShareCardLineCountMutationVariables>;

          

          export const useUpdateShareCardLineCountMutation = (options?:MutationHookOptions<UpdateShareCardLineCountMutation, UpdateShareCardLineCountMutationVariables>) => useMutation(UpdateShareCardLineCount, options);
          

          export type UpdateShareCardLineCountMutationOptions = MutationHookOptions<UpdateShareCardLineCountMutation, UpdateShareCardLineCountMutationVariables>;

          

          export type UpdateShareCardLineCountMutationResult = ReturnType<typeof useUpdateShareCardLineCountMutation>[1];

          
